export default "__VITE_ASSET__$QQbuOQ5__"